import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Box,
  Slide
} from '@material-ui/core';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import { useTheme } from '@material-ui/core/styles';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const TermsContent = () => (
  <>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      Welcome to Mayura Logistics. These Terms & Conditions define the rules and guidelines for using our website, services, and delivery solutions. By accessing our platform or using our services, you agree to comply with these terms.
    </Typography>

    <Typography variant="h6" sx={{ mt: 3, mb: 1, color: 'text.primary', fontWeight: 'bold' }}>
      1. About Our Services
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      Mayura Logistics provides delivery and shipment solutions including local deliveries, national transportation, business shipments, and related logistics services.
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      We aim to provide reliable, secure, and efficient delivery experiences for individuals and businesses.
    </Typography>

    <Typography variant="h6" sx={{ mt: 3, mb: 1, color: 'text.primary', fontWeight: 'bold' }}>
      2. User Responsibilities
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      Users are responsible for:
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Providing accurate shipment and contact information.
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Ensuring packages comply with applicable laws and regulations.
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Providing correct pickup and delivery details.
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Using our services only for lawful purposes.
    </Typography>

    <Typography variant="h6" sx={{ mt: 3, mb: 1, color: 'text.primary', fontWeight: 'bold' }}>
      3. Shipment Guidelines
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      Customers must ensure that shipment details, package information, and delivery instructions are accurate.
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      Mayura Logistics reserves the right to refuse or restrict shipments containing prohibited or unsafe items.
    </Typography>

    <Typography variant="h6" sx={{ mt: 3, mb: 1, color: 'text.primary', fontWeight: 'bold' }}>
      4. Delivery Services
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      Delivery timelines may vary depending on:
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Pickup and delivery locations
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Package requirements
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Operational conditions
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      External factors affecting transportation
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6, mt: 1.5 }}>
      We make reasonable efforts to ensure timely delivery while maintaining service quality.
    </Typography>

    <Typography variant="h6" sx={{ mt: 3, mb: 1, color: 'text.primary', fontWeight: 'bold' }}>
      5. Payments & Charges
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      Service charges are calculated based on applicable delivery requirements, distance, shipment type, and other service factors.
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      Any additional charges will be communicated where applicable.
    </Typography>

    <Typography variant="h6" sx={{ mt: 3, mb: 1, color: 'text.primary', fontWeight: 'bold' }}>
      6. Account & Information
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      Users are responsible for maintaining accurate information associated with their accounts and bookings.
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      Mayura Logistics may use provided information to process bookings, improve services, and communicate updates.
    </Typography>

    <Typography variant="h6" sx={{ mt: 3, mb: 1, color: 'text.primary', fontWeight: 'bold' }}>
      7. Limitation of Liability
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      Mayura Logistics takes reasonable care in handling shipments but is not responsible for delays caused by circumstances beyond reasonable control.
    </Typography>

    <Typography variant="h6" sx={{ mt: 3, mb: 1, color: 'text.primary', fontWeight: 'bold' }}>
      8. Changes to Terms
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      Mayura Logistics may update these Terms & Conditions from time to time. Updated terms will be published on this page.
    </Typography>
  </>
);

const PrivacyContent = () => (
  <>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      At Mayura Logistics, we respect your privacy and are committed to protecting your personal information.
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      This Privacy Policy explains how we collect, use, and protect information when you use our services.
    </Typography>

    <Typography variant="h6" sx={{ mt: 3, mb: 1, color: 'text.primary', fontWeight: 'bold' }}>
      1. Information We Collect
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      We may collect:
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Name and contact details
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Pickup and delivery information
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Shipment details
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Account information
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Communication records
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Website usage information
    </Typography>

    <Typography variant="h6" sx={{ mt: 3, mb: 1, color: 'text.primary', fontWeight: 'bold' }}>
      2. How We Use Your Information
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      Information collected may be used to:
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Process and manage deliveries
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Provide shipment updates
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Improve our services
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Communicate important information
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Maintain security and prevent misuse
    </Typography>

    <Typography variant="h6" sx={{ mt: 3, mb: 1, color: 'text.primary', fontWeight: 'bold' }}>
      3. Data Protection
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      We take reasonable measures to protect customer information against unauthorized access, misuse, or disclosure.
    </Typography>

    <Typography variant="h6" sx={{ mt: 3, mb: 1, color: 'text.primary', fontWeight: 'bold' }}>
      4. Sharing of Information
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      We do not sell personal information.
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      Information may be shared only when required to:
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Complete delivery services
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Work with service partners
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', ml: 2, display: 'list-item' }}>
      Comply with legal requirements
    </Typography>

    <Typography variant="h6" sx={{ mt: 3, mb: 1, color: 'text.primary', fontWeight: 'bold' }}>
      5. Cookies & Website Usage
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      Our website may use cookies or similar technologies to improve user experience, analyze usage, and enhance website performance.
    </Typography>

    <Typography variant="h6" sx={{ mt: 3, mb: 1, color: 'text.primary', fontWeight: 'bold' }}>
      6. User Rights
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      Users may request information updates or corrections regarding their personal information by contacting Mayura Logistics.
    </Typography>

    <Typography variant="h6" sx={{ mt: 3, mb: 1, color: 'text.primary', fontWeight: 'bold' }}>
      7. Policy Updates
    </Typography>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5, lineHeight: 1.6 }}>
      This Privacy Policy may be updated periodically to reflect changes in our services or legal requirements.
    </Typography>
  </>
);

export default function LegalModal({ open, onClose, type }) {
  const theme = useTheme();
  
  const title = type === 'terms' ? 'Terms & Conditions' : 'Privacy Policy';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: { xs: 2, md: 3 },
          bgcolor: '#ffffff',
          boxShadow: '0 24px 48px rgba(0,0,0,0.1)',
        }
      }}
    >
      <DialogTitle disableTypography sx={{ m: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Typography variant="h5" sx={{ fontWeight: 800, color: theme.palette.primary.main }}>
          {title}
        </Typography>
        <IconButton onClick={onClose} sx={{ color: 'text.secondary', '&:hover': { bgcolor: 'rgba(0,0,0,0.04)' } }}>
          <Icon icon={closeFill} width={24} height={24} />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ p: { xs: 3, md: 5 } }}>
        <Box sx={{ pr: 1 }}>
          {type === 'terms' ? <TermsContent /> : <PrivacyContent />}
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ p: 3, borderTop: '1px solid', borderColor: 'divider' }}>
        <Button 
          onClick={onClose} 
          variant="contained" 
          color="primary" 
          size="large"
          sx={{ 
            borderRadius: 2, 
            px: 5, 
            fontWeight: 700,
            textTransform: 'none'
          }}
        >
          I Understand
        </Button>
      </DialogActions>
    </Dialog>
  );
}
